function e(r) {
  return typeof r == "string" ? document.querySelector(r) : r();
}
export {
  e as resolveTo
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vueuc@0.4.64_vue@3.5.18/~/vueuc/es/shared/resolve-to.js
// module id = 1742
// module chunks = 41